



































































































































































































































































































































































































import { Component, Vue, Ref, Watch, Prop, PropSync } from "vue-property-decorator";
import store from "@/store";
// external libraries
import { latLng, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LControl, LPopup, LTooltip, LIcon, LPolyline, LCircleMarker } from "vue2-leaflet";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
import L from "leaflet";
import TimezonesGeoJson from "@/assets/data/TimezonesGeoJson";
import ECAZonesGeo from "@/assets/data/ECAZonesGeo";
import moment from "moment";
// utilities
import performanceStatusHelper from "Utilities/performance-status-helper";
import vesselMapHelper from "Utilities/vessel-map-helper";
import dateHelper from "Utilities/date-helper";
// types
import { MapMarker, MapPrevMarker } from "@/types/mapMarker";
import { VesselStatusIcons } from "@/types/vesselStatusIcons";
import { VesselHistories } from "@/types/vesselHistory";
import { MapSettings } from "@/types/mapSettings";
import { DashboardI } from "@/types/dashboard";
import { VesselGroup } from "@/types/vesselGroup";
import { ExtendedVessel } from "@/types/vessel";
// modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import MapWidgetModule from "@/store/clients/MapWidget.module";
import VesselGroupsModule from "@/store/clients/VesselGroups.module";
import VesselsHistoriesModule from "@/store/clients/VesselsHistories.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import DashboardModule from "@/store/clients/Dashboard.module";
import { format } from "highcharts";

const Vessels = getModule(VesselsModule, store);
const VesselGroups = getModule(VesselGroupsModule, store);
const VesselsHistories = getModule(VesselsHistoriesModule, store);
const MapWidgetData = getModule(MapWidgetModule, store);
const Snackbar = getModule(SnackbarModule, store);
const Dash = getModule(DashboardModule, store);

@Component({
  components: {
    LMap,
    LTileLayer,
    LControl,
    LPopup,
    LTooltip,
    LIcon,
    LPolyline,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
    LCircleMarker,
  },
})
export default class Map extends Vue {
  @Prop({ required: true }) vessels!: ExtendedVessel[];
  @Prop({ default: false }) enableMinimalMode!: boolean;
  @Prop() resizing!: boolean;
  @PropSync("vesselsMissingPosition") syncVesselsMissingPosition!: MapMarker[];
  @Ref("mapRef") mapRef!: Vue[];
  @Ref("markerRef") markerRef!: Vue[];

  // @Data
  HOUR_IN_MS = 3600000;
  map: any = null;
  mapLoading = false;
  maxZoom = 14;
  minZoom = 2;
  url = `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${process.env.VUE_APP_CARTO_API_KEY}`;
  attribution = "CARTO";
  maxBounds = latLngBounds(latLng(-85, -200), latLng(85, 200));
  mapSettings: any = {};
  mapSettingsList!: MapSettings[];
  showFilters = false;
  isMapSettingsOpen = false;
  showAllPopups = false;
  showTimezonesGrid = false;
  showECAZonesGrid = false;
  //  marker icon size
  iconSize = [12, 29];
  prevIconSize = [12, 12];
  //  number of days to show track records (prevMarkers and polyline)
  trackHistoryTimespan = 14;
  //all markers
  markers: MapMarker[] = [];
  //min distance between track markers
  minMarkerDistance = 30;
  //set marker rotation origin to be center of icon instead of bottom
  markerRotationOrigin = "center center";
  //vessel name filter
  nameFilter = "";
  //holds reference to setInterval to refresh map data
  refreshTimer!: number;
  //How long the notification is shown on screen in ms
  showVesselTrack = true;
  leafletLayerGroup: any;
  mapOptions = {
    zoomSnap: 0.5,
    wheelPxPerZoomLevel: 30,
    preferCanvas: false,
  };
  popupOptions = {
    direction: "left",
    autoClose: false,
    opacity: 1,
    closeOnClick: false,
    closeButton: false,
    offset: [-10, 0],
    className: "map-widget__custom-leaflet-popup",
  };
  polylineOptions = {
    weight: 1,
    opacity: 1,
    color: "#84CAFF",
    smoothFactor: 2.0,
  };
  tooltipOptions = {
    direction: "left",
    offset: [-10, 0],
    opacity: 1,
  };

  // @Watchers
  @Watch("resizing")
  resized(val: boolean): void {
    if (val && this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
        this.mapLoading = false;
      }, 1000);
    }
  }

  //fitBounds zooms and pans map to fit all visible markers
  @Watch("filteredMarkers")
  markersChanged(): void {
    this.fitBounds();
  }

  //toggle show all popups
  @Watch("showAllPopups")
  showAllPopupsChanged(val: boolean): void {
    //  delay to get time for leaflet to load and display markers
    setTimeout(() => {
      if (!this.markerRef.length) return;
      if (val) {
        this.markerRef.forEach(marker => {
          (marker as any).mapObject._popup.options.autoPan = false;
          (marker as any).mapObject.openPopup();
        });
      } else {
        this.markerRef.forEach(marker => {
          (marker as any).mapObject.closePopup();
        });
      }
    }, 500);

    // save map settings
    this.mapSettings.vesselNamesAndTracks = val;
  }

  @Watch("showTimezonesGrid")
  showTimezonesGridChanged(val: boolean): void {
    if (val) {
      this.leafletLayerGroup.addLayer(this.timezonesLayer);
    } else {
      this.leafletLayerGroup.removeLayer(this.timezonesLayer);
    }
    // save map settings
    this.mapSettings.timezoneGrid = val;
  }

  @Watch("showECAZonesGrid")
  showECAZonesChanged(val: boolean): void {
    if (val) {
      this.leafletLayerGroup.addLayer(this.ECAZonesLayer);
    } else {
      this.leafletLayerGroup.removeLayer(this.ECAZonesLayer);
    }
    // save map settings
    this.mapSettings.showECAZonesGrid = val;
  }

  @Watch("mapSettings", { deep: true })
  saveMapSettings(): void {
    const stringMapSettingsList: string | null = localStorage.getItem("mapSettingsList");
    //  if not null or undefined
    if (stringMapSettingsList != null) {
      this.mapSettingsList = JSON.parse(stringMapSettingsList);
      const existingSettingIndex = this.mapSettingsList.findIndex((setting: MapSettings) => setting.dashboardId === this.mapSettings.dashboardId);
      existingSettingIndex !== -1 ? (this.mapSettingsList[existingSettingIndex] = this.mapSettings) : this.mapSettingsList.push(this.mapSettings);
      localStorage.setItem("mapSettingsList", JSON.stringify(this.mapSettingsList));
    } else {
      this.mapSettings = this.defaultMapSettings;
      localStorage.setItem("mapSettingsList", JSON.stringify([this.mapSettings]));
    }
  }

  // @Getters
  get performanceStatuses(): { title: string; value: string; icon: VesselStatusIcons }[] {
    return MapWidgetData.performanceStatuses;
  }

  get activeDashboard(): DashboardI {
    return Dash.activeDashboard;
  }

  get isThemeDarkMode(): boolean {
    return this.$vuetify.theme.dark;
  }

  get themeClass(): string {
    return this.isThemeDarkMode ? "theme--dark" : "theme--light";
  }

  get filteredMarkers(): MapMarker[] {
    let filteredMarkers = this.markers;

    //filter on selected vesselgroup
    if (this.mapSettings.selectedVesselGroup?.length) {
      filteredMarkers = filteredMarkers.filter(marker => {
        return this.mapSettings.selectedVesselGroup.includes(marker.id);
      });
    }

    //filter on vessel name
    if (this.nameFilter.length) {
      filteredMarkers = filteredMarkers.filter(marker => {
        return marker.vessel.name.toLowerCase().includes(this.nameFilter.toLowerCase());
      });
    }

    //filter on performance status
    if (this.mapSettings.selectedPerformanceStatuses?.length) {
      filteredMarkers = filteredMarkers.filter(marker => {
        return this.mapSettings.selectedPerformanceStatuses.includes(marker.performanceStatus);
      });
    }

    return filteredMarkers;
  }

  get timezonesLayer(): any {
    const component = this;
    return L.geoJSON(TimezonesGeoJson as any, {
      style: function (feature) {
        return {
          color: "#c1c1c1",
          opacity: 0.5,
          weight: 2,
          fillColor: component.timezonesGridColor(feature?.properties.zone),
          fillOpacity: 0.2,
        };
      },
    }).bindPopup(function (layer: any) {
      const localDateTime = new Intl.DateTimeFormat("en-GB", {
        timeZone: layer.feature.properties.tz_name1st,
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date());
      return `
                <b>Timezone:</b> ${layer.feature.properties.time_zone} <br />
                <b>Local time:</b> ${localDateTime}
                `;
    });
  }

  get ECAZonesLayer(): any {
    return L.geoJSON(ECAZonesGeo as any, {
      style: {
        color: "#dbfdd1",
        opacity: 0.5,
        weight: 2,
        fillColor: "green",
        fillOpacity: 0.2,
      },
    });
  }

  get timezonesGridColor() {
    return function (zone: number) {
      if (zone === 0) return "#282828";
      return zone % 2 == 0 ? "#FFF" : "#c1c1c1";
    };
  }

  get isFiltersApplied(): boolean {
    return Boolean(this.mapSettings.selectedVesselGroup?.length > 0 || this.mapSettings.selectedPerformanceStatuses?.length < 5);
  }

  get defaultMapSettings(): MapSettings {
    return {
      dashboardId: this.activeDashboard.id,
      selectedPerformanceStatuses: ["Ok", "Observe", "NotOk", "BenchMarking", "notAvailable"],
      selectedVesselGroup: [],
      vesselNamesAndTracks: false,
      timezoneGrid: false,
      showECAZonesGrid: false,
      zoom: this.map.getZoom(),
      center: this.map.getCenter(),
    };
  }

  // @Methods
  onMapPopupOpen(marker: MapMarker): void {
    marker.loadingTrackHistory = true;
    this.showTrackRecords(marker);
    if (this.map.getZoom() >= 4) this.refreshPrevMarkers(marker);
  }

  onMapPopupClose(marker: MapMarker): void {
    marker.showTrackHistory = false;
    marker.expanded = false;
  }

  onMoveEnd(): void {
    // save map center
    if (this.map.getZoom() > 2.5) this.mapSettings.center = this.map.getCenter();
  }

  onMapZoomEnd(): void {
    // save map zoom level
    if (this.map.getZoom() > 2.5) this.mapSettings.zoom = this.map.getZoom();

    //  Distance between prevMarkers change on zoom, so we need to refresh them.
    //  wrapped in settimeout to add it to js tasks queue which improve map update
    setTimeout(() => {
      //  get markers ids that is currently visible in map viewport
      const mainMarkersInViewIdList = this.getMainMarkersInViewIdList();
      // Show prev markers only when zoom equal or higher than 4
      if (this.map.getZoom() >= 4) {
        this.markers.forEach(marker => {
          if (mainMarkersInViewIdList.includes(marker.id) && marker.trackHistory.loaded) {
            this.refreshPrevMarkers(marker);
          }
        });
        //  Otherwise show just vessel history track line
      } else {
        this.markers.forEach(marker => (marker.trackHistory.prevMarkers = []));
      }
    });
  }

  getUnitCaption(variable: any): string {
    return variable?.unit?.caption ?? "-";
  }

  getValue(value: any, digits = 1): string {
    return typeof value === "number" ? value.toFixed(digits) : "-";
  }

  getNestedProp(obj: any, path: string, formatter?: (val: any) => string, fallback = "-"): string {
    const value = path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
    if (value === undefined || value === null) return fallback;
    return formatter ? formatter(value) : value;
  }

  getMainMarkersInViewIdList(): number[] {
    const mainMarkersInViewIdList: number[] = [];
    const map = this.map;
    map.eachLayer(function (layer: any) {
      const isLayerPolyline: boolean = layer instanceof L.Polyline;
      const isPolylineInView: boolean = isLayerPolyline ? map.getBounds().intersects(layer.getBounds()) : false;
      const polylineMainMarkerId = (layer.options as any).markerId;

      if (isLayerPolyline && isPolylineInView && polylineMainMarkerId) {
        mainMarkersInViewIdList.push((layer.options as any).markerId);
      }
    });
    return mainMarkersInViewIdList;
  }

  closePopup(vesselId: number): void {
    this.markerRef.forEach(marker => {
      if (marker.$vnode.key === vesselId) {
        (marker as any).mapObject.closePopup();
      }
    });
  }

  toggleExtendedPopup(marker: MapMarker): void {
    marker.expanded = !marker.expanded;
    const markerRef: any = this.markerRef.find(ref => ref.$vnode.key === marker.id);

    if (marker.expanded) {
      //Waiting for the resize to finish before adjusting pan to popup
      setTimeout(function () {
        markerRef?.mapObject.getPopup()._adjustPan();
      }, 100);
    }
  }

  async showTrackRecords(marker: MapMarker): Promise<void> {
    if (!marker) return;
    marker.showTrackHistory = true;

    if (!marker.trackHistory.loaded) {
      const data = { vessel: marker.vessel, timespan: this.trackHistoryTimespan };
      const vesselHistories: VesselHistories = await VesselsHistories.getVesselHistories(data);

      this.loadPolyline(marker, vesselHistories);
      marker.trackHistory.loaded = true;
    }

    marker.loadingTrackHistory = false;
  }

  async refreshPrevMarkers(marker: MapMarker): Promise<void> {
    const data = { vessel: marker.vessel, timespan: this.trackHistoryTimespan };
    const vesselHistories: VesselHistories = await VesselsHistories.getVesselHistories(data);

    this.loadPrevMarkers(marker, vesselHistories);
  }

  loadPrevMarkers(marker: MapMarker, vesselHistories: VesselHistories): void {
    const vessel = marker.vessel;
    let prevLatLng = latLng(vessel.latitude, vessel.longitude);
    marker.trackHistory.prevMarkers = [];
    vesselHistories.vesselHistories.forEach((vesselHistory, index) => {
      if (vesselHistory.latitude && vesselHistory.longitude) {
        const prevLayerPoint = (this.mapRef as any).mapObject.latLngToLayerPoint(prevLatLng);
        const prevMarker: MapPrevMarker = {
          position: latLng(vesselHistory.latitude, vesselHistory.longitude),
          heading: Math.round(vesselHistory.course),
          icon: VesselStatusIcons["PreviousPosition"],
          vesselHistory: vesselHistory,
          lastExportDate: dateHelper.getFormatedDateTimeString(vesselHistory.exportDate),
        };

        const newLayerPoint = (this.mapRef as any).mapObject.latLngToLayerPoint(prevMarker.position);

        if (newLayerPoint.distanceTo(prevLayerPoint) >= this.minMarkerDistance) {
          marker.trackHistory.prevMarkers.push(prevMarker);
          prevLatLng = latLng(vesselHistory.latitude, vesselHistory.longitude);
        }
      }
    });
  }

  loadPolyline(marker: MapMarker, vesselHistories: VesselHistories): void {
    const polyline = vesselMapHelper.createPolylinesForMapWidget(vesselHistories.vesselHistories);
    marker.trackHistory.polyline = polyline;
  }

  //fit bounds to markers
  fitBounds(): void {
    if (!this.filteredMarkers.length) return;
    this.map.fitBounds(
      this.filteredMarkers.map(m => {
        return [m.position.lat, m.position.lng];
      }),
      { maxZoom: 7 }
    );
  }

  mapLoaded(): void {
    const ref: any = this.mapRef;
    this.map = ref.mapObject;
    this.leafletLayerGroup = L.layerGroup();
    this.leafletLayerGroup.addTo(this.map);
    this.map.getRenderer(this.map).options.padding = 10;
    this.map.zoomControl.setPosition("bottomright");

    //allow time for widget to get placed and sized on dashboard before refreshing map
    //not sure if there is a better way to do this
    setTimeout(() => {
      this.setMapStoredSettings();
      this.showAllPopups = this.mapSettings.vesselNamesAndTracks;
      this.showTimezonesGrid = this.mapSettings.timezoneGrid;
      this.showECAZonesGrid = this.mapSettings.showECAZonesGrid;
      this.map.invalidateSize();
    }, 500);
  }

  setMapStoredSettings(): void {
    const stringMapSettingsList: string | null = localStorage.getItem("mapSettingsList");
    //  if not undefined or null
    if (stringMapSettingsList != null) {
      this.mapSettingsList = JSON.parse(stringMapSettingsList);
      const existingSettingIndex = this.mapSettingsList.findIndex((setting: MapSettings) => setting.dashboardId === this.activeDashboard.id);
      existingSettingIndex !== -1 ? (this.mapSettings = this.mapSettingsList[existingSettingIndex]) : (this.mapSettings = this.defaultMapSettings);
      //  delay to rewrite changes on a map object and then set saved center and zoom
      setTimeout(() => {
        this.map.setView([this.mapSettings?.center?.lat, this.mapSettings?.center?.lng], this.mapSettings?.zoom);
      }, 500);
    } else {
      this.mapSettings = this.defaultMapSettings;
    }
  }

  //generate markers
  createMarkers(): void {
    this.markers = [];
    this.syncVesselsMissingPosition = [];
    this.vessels.forEach(vessel => {
      //returns a string that can be either as valid key of the VesselStatusIcon enum, or something else
      let performanceStatus: any = performanceStatusHelper.getPerformanceStatus(vessel);
      let iconUrl = VesselStatusIcons[performanceStatus] as unknown as VesselStatusIcons;
      //when it is not a valid key, set it to 'notAvailable'
      if (!iconUrl) {
        performanceStatus = "notAvailable";
        iconUrl = VesselStatusIcons["notAvailable"];
      }

      const marker: MapMarker = {
        id: vessel.id,
        position: latLng(vessel.latitude, vessel.longitude),
        heading: Math.round(vessel.course),
        icon: iconUrl,
        vessel: vessel,
        performanceStatus: performanceStatus,
        expanded: false,
        lastExportDate: dateHelper.getFormatedDateTimeString(vessel.lastExportDate),
        trackHistory: {
          loaded: false,
          polyline: [],
          prevMarkers: [],
        },
        showTrackHistory: false,
        loadingTrackHistory: false,
      };
      //only add vessels with both lat and long data
      //should we list vessels missing positional data in some way?
      if (vessel.latitude && vessel.longitude) {
        this.markers.push(marker);
      } else {
        this.syncVesselsMissingPosition.push(marker);
      }
    });
  }

  //refresh data and show notification
  async refreshData(): Promise<void> {
    if (Vessels.extendedVesselsExpired) {
      await Vessels.refreshExtendedVessels();
    }
    this.createMarkers();
  }

  onSelectedVesselGroupChange(): void {
    if (this.mapSettings.vesselNamesAndTracks) {
      //  Needs to be in an event loop queue to trigger after the map rewrite markers
      setTimeout(() => this.showAllPopupsChanged(true));
    }
  }

  onNameFilterChange(val: string): void {
    if (this.mapSettings.vesselNamesAndTracks && val === "") {
      //  Needs to be in an event loop queue to trigger after the map rewrite markers
      setTimeout(() => this.showAllPopupsChanged(true));
    }
  }

  async refreshVesselGroups(): Promise<void> {
    try {
      await VesselGroups.refreshVesselGroups();
    } catch (error) {
      console.warn("An error occured while loading map widget", error);
      Snackbar.showSnackbar({ text: "An error occurred while loading map widget." });
    }
  }

  async onTrackClick(marker: MapMarker): Promise<void> {
    await this.refreshPrevMarkers(marker);
    this.$emit("onTrackClicked", marker);
  }

  onMarkerClick(marker: MapPrevMarker): void {
    this.$emit("onMarkerClicked", marker);
  }

  convertTimestamp(timestamp: number): string {
    return dateHelper.getFormatedDateTimeString(timestamp);
  }
  //map data is refreshed once per hour
  startRefreshTimer(): void {
    this.refreshTimer = setInterval(() => {
      this.refreshData();
    }, this.HOUR_IN_MS);
  }

  onShowVesselTrackChange(showVesselTrack: boolean): void {
    if (showVesselTrack) this.showTrackRecords(this.markers[0]);
    else this.markers[0].showTrackHistory = false;
  }

  formatDate(date: string): string {
    return moment(date).format("llll");
  }

  // @Hooks
  async created(): Promise<void> {
    await this.refreshVesselGroups();
    this.refreshData();
    this.startRefreshTimer();
  }

  beforeDestroy(): void {
    clearInterval(this.refreshTimer);
  }
}
